import { configureStore } from '@reduxjs/toolkit';
import rootReducer from '../reducers';
import initialState from '../reducers/initialState';

function createAppStore() {
  return configureStore({
    reducer: rootReducer,
    preloadedState: initialState
  });
}

export default createAppStore;